import { createSelector } from "reselect";
import { getShipping } from "./selectors.internal.js";
const getPreferredShippingMethod = createSelector(
  getShipping,
  (shipping) => shipping.preferredMethodKey
);
export {
  getPreferredShippingMethod
};
//# sourceMappingURL=selectors.js.map
